export var FavoritesRoutes;
(function (FavoritesRoutes) {
    FavoritesRoutes["FAVORITES"] = "favorites";
})(FavoritesRoutes || (FavoritesRoutes = {}));
